<template>
  <router-view></router-view>
</template>

<script>
export default { name: 'App' }
</script>

<style>
  #app {
    font-family: 'Consolas', '微软雅黑', monospace, 'Microsoft YaHei', 'hw-iconfont';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--ccs-primary-font-color);
  }

  /* 控制按钮样式 */
  .ControlButton {
    border: 2px solid var(--ccs-primary-color);
    background: unset;
    color: var(--ccs-primary-font-color);
    padding: 7px 25px 8px 25px;
    border-radius: 20px;
    box-sizing:initial;
  }

  .ControlButton:hover {
    background: var(--ccs-primary-color) !important;
    border-color: var(--ccs-primary-color);
    color: #fff !important;
    font-weight: bold;
  }

  .ControlButton:active {
    background: var(--ccs-primary-color) !important;
    border-color: var(--ccs-primary-color);
  }

  /* 覆盖 vue3-contextmenu 默认样式 */
  .v-contextmenu {
    background-color: #fff !important;
    border: 1px solid #eee !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    padding: 5px 0 !important;
    border-radius: 6px !important;
  }

  .v-contextmenu-item {
    color: #333 !important;
    padding: 8px 16px !important;
    font-size: 13px !important;
    background-color: transparent !important;
    transition: all 0.2s !important;
  }

  .v-contextmenu-item:hover {
    background-color: #f5f5f5 !important;
    color: var(--ccs-primary-color) !important;
  }

  .v-contextmenu-divider {
    border-bottom: 1px solid #eee !important;
    margin: 4px 0 !important;
    background-color: transparent !important;
  }
</style>
